import React from 'react';

const ObjectivePage: React.FC = () => {
    return (
        <div>
            ObjectivePage
        </div>
    );
};

export { ObjectivePage }
